module.exports = __webpack_public_path__ + "static/img/14000780.875679ea.png";